/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown>, task: NonNullable<unknown> }} Email_Task_Assigned_SubjectInputs */

const en_email_task_assigned_subject = /** @type {(inputs: Email_Task_Assigned_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case ${i?.caseNumber}: ${i?.task}`)
};

const pt_br2_email_task_assigned_subject = /** @type {(inputs: Email_Task_Assigned_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso ${i?.caseNumber}: ${i?.task}`)
};

/**
* | output |
* | --- |
* | "Case {caseNumber}: {task}" |
*
* @param {Email_Task_Assigned_SubjectInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_subject = /** @type {((inputs: Email_Task_Assigned_SubjectInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_SubjectInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_subject(inputs)
	return pt_br2_email_task_assigned_subject(inputs)
});